import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import images from '../../data/images.json';
import ImageLightbox from '../../components/ImageLightbox/ImageLightbox';
import './Gallery.css';

const Gallery: React.FC = () => {
  const { t } = useTranslation();
  const galleryImages = images.gallery || [];
  const [selectedImage, setSelectedImage] = useState<{ src: string; alt: string } | null>(null);

  const handleImageClick = (image: string, index: number) => {
    setSelectedImage({
      src: image,
      alt: `${t('gallery.title')} ${index + 1}`
    });
  };

  const handleCloseLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <div className="container">
          <h1 className="page-title">{t('gallery.title')}</h1>
        </div>
      </section>

      <section className="gallery-section">
        <div className="container">
          <div className="gallery-grid">
            {galleryImages.map((image: string, index: number) => (
              <div key={index} className="gallery-item" onClick={() => handleImageClick(image, index)}>
                <img
                  src={image}
                  alt={`${t('gallery.title')} ${index + 1}`}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = 'https://via.placeholder.com/400x400/f4c430/333333?text=Gallery';
                  }}
                />
                <div className="gallery-overlay">
                  <button className="view-button">{t('gallery.view')}</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedImage && (
        <ImageLightbox
          image={selectedImage.src}
          alt={selectedImage.alt}
          onClose={handleCloseLightbox}
        />
      )}
    </div>
  );
};

export default Gallery;

